<template>
    <div class="monitorEarlyWarning">
        <van-nav-bar
            title="监控预警"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="banner"></div>
        <div class="menus">
            <div class="row">
                <div class="item item1" @click="openPage(1)">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>物流监控</p>
                </div>
                <!-- <div class="item item2" @click="openPage(2)">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>视频监控</p>
                </div> -->
                <div class="item item3" @click="openPage(3)">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>异常打料</p>
                </div>
                <div class="item item4" @click="openPage(4)">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>异常配比</p>
                </div>
                <div class="item item5" @click="openPage(5)">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>实时库存</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        openPage(type) {
            this.$router.isBack = 2;
            if (type === 1) {
                this.$router.push({ name: 'logisticsMonitoring' });
            } else if (type === 2) {
                this.$router.push({ name: 'monitoringList' });
            } else if (type === 3) {
                this.$router.push({
                    name: 'abnormalProduction',
                    params: {
                        type: 'abnormalPunching',
                    } });
            } else if (type === 4) {
                this.$router.push({ name: 'abnormalMix' });
            } else if (type === 5) {
                this.$router.push({
                    name: 'abnormalProduction',
                    params: {
                        type: 'realTimeMonitoring',
                    },
                });
            }
        },
    },
};
</script>
<style lang="stylus">
.monitorEarlyWarning
    height 100%
    .iconsend
        background: linear-gradient(180deg, #EFAB54 0%, #FA8C47 100%);
        -webkit-background-clip text
        -webkit-text-fill-color transparent
    .banner
        height 184rpx
        background url(./images/bg@2x.png) no-repeat
        background-size 100% 100%
    .menus
        padding 30rpx 0 30rpx 30rpx
        .row
            overflow hidden
            .item
                float left
                width 85rpx
                height 85rpx
                background url(./images/cxqk.png) no-repeat
                background-size 100% 100%
                margin-right 30rpx
                margin-bottom 30rpx
                cursor pointer
                .icon-con
                    text-align center
                    margin-top 10rpx
                    .icon
                        width 34rpx
                        height 34rpx
                        background-repeat no-repeat
                        background-size 100% 100%
                        display inline-block
                p
                    font-size 14rpx
                    text-align center
                &.item1
                    .icon
                        background-image url(./images/monitor_icon_1@2x.png)
                &.item2
                    .icon
                        background-image url(./images/monitor_icon_2@2x.png)
                &.item3
                    .icon
                        background-image url(./images/monitor_icon_3@2x.png)
                &.item4
                    .icon
                        background-image url(./images/monitor_icon_4@2x.png)
                &.item5
                    .icon
                        background-image url(./images/monitor_icon_5@2x.png)
</style>
